import { ChangeDetectionStrategy, Component, forwardRef, inject, Input, OnDestroy } from '@angular/core';
import { ModalService } from '@base/services/private/modal.service';
import { ModalFooterComponent } from '@base/components/private/modals/modal-footer/modal-footer.component';
import { ModalHeaderComponent } from '@base/components/private/modals/modal-header/modal-header.component';
import { ModalBodyComponent } from '@base/components/private/modals/modal-body/modal-body.component';
import { TranslatePipe } from '@base/pipes/private/translate.pipe';
import { GlobalService } from '@base/services/private/global.service';

@Component({
  selector: 'app-modal-remove-request-meet',
  imports: [ModalFooterComponent, ModalHeaderComponent, ModalBodyComponent, forwardRef(() => TranslatePipe)],
  templateUrl: './modal-remove-request-meet.component.html',
  styleUrl: './modal-remove-request-meet.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalRemoveRequestMeetComponent implements OnDestroy {
  private readonly modalSrv = inject(ModalService);
  private readonly globalSrv = inject(GlobalService);

  @Input() modalId = '';
  @Input() name = '';
  @Input() peopleId = '';

  ngOnDestroy(): void {
    this.globalSrv.destroyModalRef(this.modalId);
  }

  /**
   * Closes the modal or all modals depending on the `closeAll` flag,
   * and updates the request label service with the removal event.
   * @returns void
   */
  close(): void {
    this.modalSrv.close();
  }
}
